import { ThunkType } from "../../../../core/store/reducers";
import { setData } from "../accountingOrderDataSlice";
import getAccountingOrdereWebApi from "../api/getAccountingOrderData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.accounting.accountingOrder;

  const pagedTrades = await dispatch(getAccountingOrdereWebApi(user, filter));

  dispatch(setData(pagedTrades || []));
};
